"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils"); // solve cyclic dependency


var causalAnalysisQuestionScale = ["Not sure what’s expected in order to do well academically", "Current subjects not interesting/engaging", "Overloaded by my study workload", "Family/personal issue", "Don’t feel connected to or interested in fellow students", "Not happy with the quality of teaching or learning materials", "My grades so far have been poor or very poor", "Not getting enough guidance from my teachers", "I’m worried about my finances", "Difficulty balancing study with work or family commitments", "Don’t think I have the skills and abilities to succeed academically", "N/A"];
var likertLikeScale = ["At no time", "Some of the time", "Less than half the time", "More than half the time", "Most of the time", "All of the time"];
var questions = screenersImport.expandscreeners([utils.screeners.WHO5, {
  batteryId: "WHO5",
  question: "The following things have made it hard for me to be effective in my studies:",
  scale: causalAnalysisQuestionScale
}]);

var analysis = function analysis(answers, bonus) {
  // Add the bonus question to answer array so can extract the results
  bonus && bonus.causal ? answers.push(bonus.causal) : bonus ? answers.push(bonus) : null;
  if (!answers) return null;
  var results = {};
  [utils.screeners.WHO5].forEach(function (battery) {
    results = Object.assign(results, screenersImport.extractResults(questions, answers, battery));
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i]);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};